<template>
  <router-view />
</template>

<script>
import api from "@/api";

export default {
  name: "App",
  data: () => ({ minuterie: null }),
  mounted() {
    // Compte désactivé ou abonnement suspendu pendant la journée : on le voit en moins d'une minute
    this.minuterie = setInterval(async () => {
      if (!this.$store.state.token || !this.$store.state.user) return;
      try {
        const { data } = await this.$api.getMe();
        if (data.enabled === false) {
          this.$store.dispatch("logout");
          this.$router.push({ path: "/login", query: { message: "Votre compte a été désactivé." } });
        }
      } catch (e) { /* coupure réseau : on réessaiera */ }
    }, 60000);
  },
  beforeUnmount() { clearInterval(this.minuterie); },
  computed: { $api() { return api; } }
};
</script>
